import { createContext } from 'react';
import { ILocationService, IScope, IRootScopeService } from 'angular';

const Context = createContext<{
  $location?: ILocationService;
  $scope?: IScope;
  $rootScope?: IRootScopeService;
  ToastService?: any;
}>({});

export default Context;
